import { render, staticRenderFns } from "./Rule58ResponseInstructions.vue?vue&type=template&id=37376a66&scoped=true"
import script from "./Rule58ResponseInstructions.vue?vue&type=script&lang=ts"
export * from "./Rule58ResponseInstructions.vue?vue&type=script&lang=ts"
import style0 from "./Rule58ResponseInstructions.vue?vue&type=style&index=0&id=37376a66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37376a66",
  null
  
)

export default component.exports